import { render, staticRenderFns } from "./recommendation-dialog.vue?vue&type=template&id=4574d08c&"
import script from "./recommendation-dialog.vue?vue&type=script&lang=js&"
export * from "./recommendation-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports